import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export const GhVirtualAton: React.FC<IconProps> = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      className={className}
      {...props}
    >
      <rect
        x="15"
        y="15"
        width="70"
        height="70"
        fill="none"
        stroke="black"
        strokeDasharray="15"
        strokeWidth="2.5"
        transform="rotate(45 50 50)"
      />
      <line x1="50" y1="30" x2="50" y2="70" stroke="black" strokeWidth="3" />
      <line x1="30" y1="50" x2="70" y2="50" stroke="black" strokeWidth="3" />
    </svg>
  );
};
